import { Injectable, signal } from '@angular/core';

export type AlertType = 'success' | 'error' | 'info' | 'warning';

export interface AppAlert {
  id: number;
  type: AlertType;
  message: string;
}

@Injectable({
  providedIn: 'root',
})
export class AlertService {
  private nextId = 0;
  readonly alerts = signal<AppAlert[]>([]);

  success(message: string, duration = 4500): void {
    this.show('success', message, duration);
  }

  error(message: string, duration = 5500): void {
    this.show('error', message, duration);
  }

  info(message: string, duration = 4000): void {
    this.show('info', message, duration);
  }

  warning(message: string, duration = 4500): void {
    this.show('warning', message, duration);
  }

  dismiss(id: number): void {
    this.alerts.update((items) => items.filter((item) => item.id !== id));
  }

  private show(type: AlertType, message: string, duration: number): void {
    const id = ++this.nextId;
    this.alerts.update((items) => [...items, { id, type, message }]);

    window.setTimeout(() => this.dismiss(id), duration);
  }
}
